import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { PageContainer, Section } from '../../../shared/ui';
import { appendYowanPreviewQueryIfNeeded } from '../../../app/host/yowanPreviewRouting';
import { confirmYowanPasswordReset } from '../app/yowanAuthClient';
import { readYowanAuthAdapter } from '../app/yowanAuthAdapter';
const { yowanPageContent } = require('./pageContent');
const { getYowanRouteMeta } = require('../routes/manifest');

const PasswordResetConfirmPage = () => {
  const content = yowanPageContent['/password-reset/confirm'];
  const metadata = getYowanRouteMeta('/password-reset/confirm');
  const location = useLocation();
  const navigate = useNavigate();
  const auth = readYowanAuthAdapter();
  const currentUser = auth.currentUser;
  const [submitFeedback, setSubmitFeedback] = useState({ message: '', isError: false });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      token: '',
      new_password: '',
      new_password_confirm: '',
    },
  });

  useEffect(() => {
    if (!metadata) {
      return;
    }

    document.title = metadata.title;

    if (metadata.description) {
      const descriptionTag = document.querySelector('meta[name="description"]');
      if (descriptionTag) {
        descriptionTag.setAttribute('content', metadata.description);
      }
    }
  }, [metadata]);

  const onSubmit = async (values) => {
    try {
      await confirmYowanPasswordReset({
        token: values.token,
        newPassword: values.new_password,
      });
      setSubmitFeedback({
        message: 'パスワードを変更しました',
        isError: false,
      });
      navigate(appendYowanPreviewQueryIfNeeded('/login', location.search));
    } catch (error) {
      setSubmitFeedback({
        message: 'パスワード再設定の確定に失敗しました。入力内容をご確認ください。',
        isError: true,
      });
    }
  };

  return (
    <Section>
      <PageContainer>
        <div className="yowan-auth-support-shell">
          <div className="yowan-auth-support-panel c-surface-content">
            <div className="yowan-auth-support-panel__body">
              <h1 className="yowan-auth-support-panel__title">{content.header.title}</h1>
              {content.header.paragraphs.map((paragraph) => (
                <p key={paragraph} className="yowan-auth-support-panel__lead">
                  {paragraph}
                </p>
              ))}
              {currentUser.isAuthenticated ? (
                <p className="yowan-auth-support-panel__lead">
                  現在ログイン済みです。パスワードを変更する場合は、マイページからお手続きください。
                  <br />
                  <a
                    href={appendYowanPreviewQueryIfNeeded('/mypage', location.search)}
                    className="yowan-auth-support-form__message"
                  >
                    マイページへ
                  </a>
                </p>
              ) : null}
            </div>

            <form className="yowan-auth-support-form c-form" onSubmit={handleSubmit(onSubmit)}>
              <label className="c-form__field">
                <span className="c-form__label">
                  {content.form.labels.token}
                  <em className="c-form__required">*</em>
                </span>
                <input
                  className="c-form__control"
                  type="text"
                  {...register('token', { required: content.form.errors.required })}
                />
                {errors.token ? (
                  <em className="yowan-auth-support-form__error">{errors.token.message}</em>
                ) : null}
              </label>

              <label className="c-form__field">
                <span className="c-form__label">
                  {content.form.labels.newPassword}
                  <em className="c-form__required">*</em>
                </span>
                <input
                  className="c-form__control"
                  type="password"
                  {...register('new_password', { required: content.form.errors.required })}
                />
                {errors.new_password ? (
                  <em className="yowan-auth-support-form__error">{errors.new_password.message}</em>
                ) : null}
              </label>

              <label className="c-form__field">
                <span className="c-form__label">
                  {content.form.labels.newPasswordConfirm}
                  <em className="c-form__required">*</em>
                </span>
                <input
                  className="c-form__control"
                  type="password"
                  {...register('new_password_confirm', {
                    required: content.form.errors.required,
                    validate: (value) =>
                      value === watch('new_password') || content.form.errors.passwordMismatch,
                  })}
                />
                {errors.new_password_confirm ? (
                  <em className="yowan-auth-support-form__error">{errors.new_password_confirm.message}</em>
                ) : null}
              </label>

              <button type="submit" className="c-form__submit">
                {content.form.submitLabel}
              </button>

              {submitFeedback.message ? (
                <p
                  className={
                    submitFeedback.isError
                      ? 'yowan-auth-support-form__error'
                      : 'yowan-auth-support-form__message'
                  }
                >
                  {submitFeedback.message}
                </p>
              ) : null}
            </form>
          </div>
        </div>
      </PageContainer>
    </Section>
  );
};

export default PasswordResetConfirmPage;
